import { FETCH_PROVINCES_REQUEST, FETCH_PROVINCES_SUCCESS, FETCH_PROVINCES_ERROR } from '../constants/ActionTypes';

export default function isFetchingProvinces(state = false, action) {
    switch (action.type) {
        case FETCH_PROVINCES_REQUEST:
            return true;
        case FETCH_PROVINCES_SUCCESS:
        case FETCH_PROVINCES_ERROR:
            return false;
        default:
            return state;
    }
}
